$ = require 'jquery'
ApiError = require 'network/api-error'
ApiPromise = undefined
queueRequire -> ApiPromise = require 'network/api-promise'
Promise = require 'bluebird'
SessionStorage = require 'lib/session-storage'
_ = require 'underscore'
f = require 'effing'
assert = require 'lib/assert'

module.exports =
  routes: [
    [':name/account', 'userOrOrgAccountView']
    [':name/billing(?*query)', 'userOrOrgBillingView']
    [':name/billing/card', 'userOrOrgBillingCardView']
    [':name/billing/card/:product', 'userOrOrgBillingCardView']
    [':name/cards', 'userOrOrgCardView']
    [':name/cards/:pageName', 'userOrOrgCardView']
    [':name(/)', 'userOrOrgProfileView']
  ]

  userOrOrgProfileView: (name = 'me') ->
    @userOrOrgView(name, @memberProfileView, @organizationBoardsView)
    return

  userOrOrgAccountView: (name = 'me') ->
    @userOrOrgView(name, @memberAccountView, @organizationAccountView)
    return

  # Billing views
  userOrOrgBillingView: (name = 'me') ->
    returnUrl =
      if (escapedReturnUrl = /returnUrl=([^&]+)/.exec(location.search)?[1])?
        decodeURIComponent(escapedReturnUrl)
      else
        undefined
    if !/^\/($|[a-zA-Z0-9])/.test(returnUrl)
      returnUrl = undefined

    @userOrOrgView(name, @memberBillingView, @organizationBillingView, { returnUrl })
    return

  userOrOrgBillingCardView: (name = 'me', product) ->
    @navigate [name, 'billing'].join('/'), replace: true, trigger: true
    return

  userOrOrgCardView: (name = 'me', pageName) ->
    @userOrOrgView(name, @memberCardsView, @memberHomeCardsView, { pageName })

  getViewData: (name) ->
    key = "typeof_#{ name }"

    # Check cache for item
    if (value = SessionStorage.get(key))?
      Promise.resolve value
    else
      ApiPromise { url: "/1/types/#{ name }" }
      .tap f(SessionStorage, 'set', key)

  userOrOrgView: (name, fxUser, fxOrganization, options = {}) ->
    @getViewData name
    .then (data) =>
      fn = switch data.type
        when 'member' then fxUser
        when 'organization' then fxOrganization

      assert fn?, "/1/types/#{name} resolved to #{data.type}"
      fn.call @, name, options
    .catch ApiError.NotFound, =>
      @displayErrorPage()
    .done()



// WEBPACK FOOTER //
// ./app/scripts/controller/user-or-org-routes.coffee